import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

export const BlogDetail = ({ blogData, allBlogs = [] }) => {
  // İlgili yazıları etiketlere göre bul
  const getRelatedPosts = () => {
    if (!blogData || !blogData.tags || !allBlogs.length) {
      return [];
    }

    const currentSlug = blogData.slug;
    const currentTags = blogData.tags || [];
    
    // Etiket eşleşmesine göre skorlama
    const scoredBlogs = allBlogs
      .filter(blog => blog.slug !== currentSlug) // Mevcut blog'u hariç tut
      .map(blog => {
        const blogTags = blog.tags || [];
        const commonTags = currentTags.filter(tag => 
          blogTags.some(blogTag => 
            blogTag.toLowerCase() === tag.toLowerCase()
          )
        );
        
        return {
          ...blog,
          score: commonTags.length,
          commonTags
        };
      })
      .filter(blog => blog.score > 0) // En az 1 ortak etiketi olanlar
      .sort((a, b) => b.score - a.score); // Skora göre sırala

    return scoredBlogs.slice(0, 3); // İlk 3'ünü al
  };

  const relatedPosts = getRelatedPosts();

  if (!blogData) {
    return (
      <div className="blog-detail-container">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="blog-not-found">
                <h1>Blog Yazısı Bulunamadı</h1>
                <p>Aradığınız blog yazısı bulunamadı.</p>
                <Link to="/" className="btn btn-custom">
                  Ana Sayfaya Dön
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="blog-detail-container">
      <Helmet>
        <title>{blogData.title} | TR Assist Blog - Yol Yardım ve Sigorta Asistans</title>
        <meta name="description" content={blogData.excerpt} />
        <meta name="keywords" content={`${blogData.title}, TR Assist blog, yol yardım, sigorta asistans, ${blogData.tags ? blogData.tags.join(', ') : ''}, kurumsal yol yardım, filo yönetimi, dijital dönüşüm`} />
        <meta name="author" content="TR Assist" />
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
        <meta name="article:published_time" content={blogData.publishDate} />
        <meta name="article:modified_time" content={blogData.lastModified || blogData.publishDate} />
        <meta name="article:section" content={blogData.category || "Yol Yardım"} />
        {blogData.tags && blogData.tags.map((tag, idx) => (
          <meta key={idx} name="article:tag" content={tag} />
        ))}
        <link rel="canonical" href={`https://www.trassist.com.tr/blog/${blogData.slug}`} />
        <link rel="alternate" hreflang="tr" href={`https://www.trassist.com.tr/blog/${blogData.slug}`} />
        
        {/* Open Graph Meta Tags */}
        <meta property="og:title" content={`${blogData.title} - TR Assist Blog`} />
        <meta property="og:description" content={blogData.excerpt} />
        <meta property="og:type" content="article" />
        <meta property="og:url" content={`https://www.trassist.com.tr/blog/${blogData.slug}`} />
        <meta property="og:image" content={blogData.image.startsWith('http') ? blogData.image : `https://www.trassist.com.tr${blogData.image}`} />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content={blogData.title} />
        <meta property="og:site_name" content="TR Assist" />
        <meta property="og:locale" content="tr_TR" />
        <meta property="article:published_time" content={blogData.publishDate} />
        <meta property="article:modified_time" content={blogData.lastModified || blogData.publishDate} />
        <meta property="article:section" content={blogData.category || "Yol Yardım"} />
        {blogData.tags && blogData.tags.map((tag, idx) => (
          <meta key={idx} property="article:tag" content={tag} />
        ))}
        <meta property="article:author" content="TR Assist" />
        
        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={`${blogData.title} - TR Assist Blog`} />
        <meta name="twitter:description" content={blogData.excerpt} />
        <meta name="twitter:image" content={blogData.image.startsWith('http') ? blogData.image : `https://www.trassist.com.tr${blogData.image}`} />
        <meta name="twitter:image:alt" content={blogData.title} />
        
        {/* BreadcrumbList Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Ana Sayfa",
                "item": "https://www.trassist.com.tr"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Blog",
                "item": "https://www.trassist.com.tr/blogs"
              },
              {
                "@type": "ListItem",
                "position": 3,
                "name": blogData.title,
                "item": `https://www.trassist.com.tr/blog/${blogData.slug}`
              }
            ]
          })}
        </script>
        
        {/* Article Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BlogPosting",
            "headline": blogData.title,
            "description": blogData.excerpt,
            "image": blogData.image.startsWith('http') ? blogData.image : `https://www.trassist.com.tr${blogData.image}`,
            "datePublished": blogData.publishDate,
            "dateModified": blogData.lastModified || blogData.publishDate,
            "author": {
              "@type": "Organization",
              "name": "TR Assist",
              "url": "https://www.trassist.com.tr",
              "logo": {
                "@type": "ImageObject",
                "url": "https://www.trassist.com.tr/img/tr_assistance_logo.svg"
              }
            },
            "publisher": {
              "@type": "Organization",
              "name": "TR Assist",
              "logo": {
                "@type": "ImageObject",
                "url": "https://www.trassist.com.tr/img/tr_assistance_logo.svg",
                "width": 600,
                "height": 60
              }
            },
            "mainEntityOfPage": {
              "@type": "WebPage",
              "@id": `https://www.trassist.com.tr/blog/${blogData.slug}`
            },
            "articleSection": blogData.category || "Yol Yardım",
            "keywords": blogData.tags ? blogData.tags.join(", ") : "yol yardım, TR Assist",
            "inLanguage": "tr-TR",
            "wordCount": blogData.content ? blogData.content.replace(/<[^>]*>/g, '').split(/\s+/).length : 0
          })}
        </script>
      </Helmet>

      {/* Blog Header */}
      <section className="blog-detail-header">
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-md-offset-2">
              <div className="blog-breadcrumb">
                <Link to="/" className="breadcrumb-link">Ana Sayfa</Link>
                <span className="breadcrumb-separator">/</span>
                <Link to="/#blog" className="breadcrumb-link">Blog</Link>
                <span className="breadcrumb-separator">/</span>
                <span className="breadcrumb-current">{blogData.title}</span>
              </div>
              
              <div className="blog-meta">
                <span className="blog-date">
                  <i className="fa fa-calendar"></i>
                  {blogData.publishDate}
                </span>
                <span className="blog-author">
                  <i className="fa fa-user"></i>
                  TR Assist
                </span>
                <span className="blog-category">
                  <i className="fa fa-tag"></i>
                  {blogData.category}
                </span>
              </div>
              
              <h1 className="blog-title">{blogData.title}</h1>
              <p className="blog-excerpt">{blogData.excerpt}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Blog Content */}
      <section className="blog-detail-content">
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-md-offset-2">
              <div className="blog-featured-image">
                <img 
                  src={blogData.image} 
                  alt={blogData.title}
                  className="img-responsive"
                />
              </div>
              
              <div className="blog-content">
                {blogData.content ? (
                  <div dangerouslySetInnerHTML={{ __html: blogData.content }} />
                ) : (
                  <div className="blog-placeholder-content">
                    <h2>İçerik Yakında Eklenecek</h2>
                    <p>Bu blog yazısının detaylı içeriği yakında eklenecektir. Şimdilik özet bilgiyi okuyabilirsiniz.</p>
                    <p>{blogData.excerpt}</p>
                    
                    <h3>TR Assist Hakkında</h3>
                    <p>TR Assist olarak, Türkiye'nin önde gelen yol yardım ve ikame araç hizmet sağlayıcısıyız. Kurumsal müşterilerimize ve sigorta şirketlerine profesyonel, güvenilir ve hızlı çözümler sunuyoruz.</p>
                    
                    <h3>Hizmetlerimiz</h3>
                    <ul>
                      <li>7/24 Yol Yardım Hizmetleri</li>
                      <li>İkame Araç Temini</li>
                      <li>Sigorta Şirketleri İçin Özel Çözümler</li>
                      <li>Kurumsal Müşteri Desteği</li>
                      <li>Türkiye Geneli Hizmet</li>
                    </ul>
                    
                    <div className="blog-cta">
                      <h3>Hizmetlerimizden Yararlanmak İster misiniz?</h3>
                      <p>TR Assist'in profesyonel yol yardım hizmetlerinden yararlanmak için bizimle iletişime geçin.</p>
                      <Link to="/#contact" className="btn btn-custom btn-lg">
                        İletişime Geç
                      </Link>
                    </div>
                  </div>
                )}
              </div>
              
              {/* Blog Tags */}
              {blogData.tags && blogData.tags.length > 0 && (
                <div className="blog-tags">
                  <h4>Etiketler:</h4>
                  <div className="tag-list">
                    {blogData.tags.map((tag, index) => (
                      <span key={index} className="tag">
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              )}
              
              {/* Social Share */}
              <div className="blog-social-share">
                <h4>Paylaş:</h4>
                <div className="social-buttons">
                  <a 
                    href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-btn facebook"
                  >
                    <i className="fa fa-facebook"></i> Facebook
                  </a>
                  <a 
                    href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(window.location.href)}&text=${encodeURIComponent(blogData.title)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-btn twitter"
                  >
                    <i className="fa fa-twitter"></i> Twitter
                  </a>
                  <a 
                    href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(window.location.href)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-btn linkedin"
                  >
                    <i className="fa fa-linkedin"></i> LinkedIn
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Related Posts */}
      {relatedPosts.length > 0 && (
        <section className="related-posts">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h3>İlgili Yazılar</h3>
                <p className="related-posts-subtitle">
                  Bu yazıyla ilgili diğer blog yazılarımızı keşfedin
                </p>
                <div className="row">
                  {relatedPosts.map((post, index) => (
                    <div key={post.slug} className="col-md-4">
                      <div className="related-post">
                        <div className="related-post-image">
                          <img 
                            src={post.image} 
                            alt={post.title} 
                            className="img-responsive"
                            onError={(e) => {
                              e.target.style.display = 'block';
                              e.target.style.background = '#f0f0f0';
                            }}
                          />
                          <div className="related-post-date">
                            <span className="day">{post.day}</span>
                            <span className="month">{post.month}</span>
                          </div>
                          {post.featured && (
                            <span className="related-post-featured">
                              <i className="fa fa-star"></i> Öne Çıkan
                            </span>
                          )}
                        </div>
                        <div className="related-post-content">
                          <div className="related-post-category">{post.category}</div>
                          <h4>{post.title}</h4>
                          <p>{post.excerpt}</p>
                          {post.commonTags && post.commonTags.length > 0 && (
                            <div className="related-post-tags">
                              <strong>Ortak etiketler:</strong>
                              <span className="common-tags">
                                {post.commonTags.map((tag, tagIndex) => (
                                  <span key={tagIndex} className="common-tag">
                                    {tag}
                                  </span>
                                ))}
                              </span>
                            </div>
                          )}
                          <Link to={post.link} className="btn btn-custom btn-sm">
                            Devamını Oku
                          </Link>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="related-posts-footer">
                  <Link to="/blogs" className="btn btn-outline-custom">
                    Tüm Blog Yazılarını Gör
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </div>
  );
}; 